var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92 1a2.922 2.922 0 00-2.923 2.922v40.154a2.922 2.922 0 002.922 2.922h32.162a2.922 2.922 0 002.922-2.922V13.647c0-.798-.327-1.56-.903-2.112L31.927 1.81a2.922 2.922 0 00-2.02-.81H7.92z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.633 1.04v10.578a1.96 1.96 0 001.961 1.96h10.044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.734 21.559h20.532m-20.532 8.213h20.532m-20.532 8.212h20.532",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.6d9d155afb16cb0ee8fd1f1afbad726c.svg";
export { ForwardRef as ReactComponent };